import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import GradingMachineProcessActions from '../../Stores/GradingMachineProcess/Actions';

import GradingMachineListTable from '../GradingMachineList/GradingMachineListTable';
import GradingMachineExcelTable from '../GradingMachineExcel/GradingMachineExcelTable';

const { TabPane } = Tabs;

class GradingMachineProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchList } = this.props;
    if (curSiteFlowId > 0) {
      fetchList();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchList } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchList();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/gradingMachine/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'GRADING_MACHINE_LIST' && (
          <GradingMachineListTable match={match} />
        )}
        {match.params.proc_type === 'GRADING_MACHINE_EXCEL' && (
          <GradingMachineExcelTable match={match} />
        )}
      </Card>
    );
  }
}

GradingMachineProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchList: PropTypes.func
};

GradingMachineProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchList() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.gradingMachineProcess.process,
  processIsLoading: state.gradingMachineProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchList: () => dispatch(GradingMachineProcessActions.gradingMachineProcessFetchList())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(GradingMachineProcessScreen));
